import { connect } from 'react-redux';
import { selectIsLoggedIn } from 'src/modules/User';

const mapStateToProps = (state) => ({
    isLoggedIn: selectIsLoggedIn(state)
});

export default connect(mapStateToProps);
